module.exports = __webpack_public_path__ + "b4661eafc29b03e8382e4dc638611f47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/samsung_gear_connect/1.png
// module id = 1835
// module chunks = 1